import React, { useRef, useState } from 'react';

import { process as kendoProcess } from '@progress/kendo-data-query';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';

import AssignTabSidePanel from './AssignTabSidePanel';

import * as classes from './AssignTab.module.css';


const initialDataState = {
    sort: [],
    take: 10,
    skip: 0
};

const AssignTab = ({
    ...props
}) => {
    const [dataState, setDataState] = useState(initialDataState);

    const gridRef = useRef(null);

    const onDataStateChange = e => {
        setDataState(e.dataState);
    };

    return (
        <div className={classes.AssignTab}>
            <AssignTabSidePanel />
            <div className={classes.Body}>
                <div className={classes.Title}>
                    Assign
                </div>
                <div className={classes.RuleTitle}>
                    Rule
                </div>
                <div className={classes.Formula}>
                    {'IF [Sensor Type A, Max 30] - [Sensor Type B, Min 30] > [0] THEN [Output A] ELSE IF [Sensor Type A, Max 30] - [Sensor Type B, Min 30] > [0] THEN [Output B]'}
                </div>
                <Grid
                    ref={gridRef}
                    sortable={{
                        mode: 'multiple'
                    }}
                    //className={classes.KendoGrid}
                    data={kendoProcess([].map((item) => ({
                        ...item, 'selected': item.selected,
                    })), dataState)}
                    {...dataState}
                    dataItemKey="id"
                    selectedField="selected"
                    selectable={{
                        enabled: true,
                        drag:    false,
                        cell:    false,
                        mode:    'multiple'
                    }}
                    onDataStateChange={onDataStateChange}
                    reorderable={false}
                >
                    <Column
                        filterable={false}
                        field="selected"
                        width={60}
                        headerSelectionValue={
                            [].length > 0 && [].findIndex((item) => item.selected) === -1
                        }
                    />
                    <Column
                        field="equipment"
                        title={'Equipment'}
                        id={'equipment'}
                        width={300}
                    />
                    <Column
                        field="enabled"
                        title={'Enable/Disable'}
                    />
                    <Column
                        field="Auto-generate Service Request From Fault"
                        title={'Auto-generate Service Request From Fault'}
                        id={'titleColumn'}
                        width="auto"
                    />
                    <Column
                        field=""
                        title=""
                        width={80}
                        locked={true}
                        sortable={false}
                        filterable={false}
                    />
                </Grid>
            </div>
        </div>
    );
};

export default AssignTab;
